import { useTranslation } from 'react-i18next'

import { z } from '@/lib/zod'

export function NewsHighlightedImageSchema() {
  const { t } = useTranslation()

  return z.object({
    postImage: z.instanceof(File, { message: t('zod:errors.invalid_type') }),
  })
}

export type NewsHighlightedImageForm = z.infer<
  ReturnType<typeof NewsHighlightedImageSchema>
>
